import styled from "styled-components";

export const ModalWrap = styled.div`
label{
    font-size: 14px;
    text-align: left;
    font-weight: 700;
    color: #3c4858;
    display: block;
}
.google-places-autocomplete__suggestion{
    cursor:pointer;
}
input{
    border: 1px solid #c0ccda !important;
    border-radius: 3px;
    background: #fff;
    margin-bottom: 6px;
    height: unset;
    padding: 7px 15px;
    width:100%;
    &:focus{
        outline:none;
    }
}
.modal-title{
    font-size: 25px;
    font-weight: 500;
    line-height: 1.2;
    font-style: normal;
    color: rgba(74,74,74,1.00);
}
.close{
    &:focus{
        outline:none !important;
    }
}
`;
export const FullWrap = styled.div`
    .modal-button{
            background: transparent;
            border: 1px solid rgba(0,0,0,.1);
            padding: .7rem 1.5rem;
            -webkit-transition: all 400ms cubic-bezier(0.445,0.5,0.55,0.95);
            transition: all 400ms cubic-bezier(0.445,0.5,0.55,0.95);
            border-radius: 50rem;
            font-size: 1rem;
            color: #474f56;
            font-weight: 600;
            width: 180px;
            margin-right:10px;
            background-color: #8cc63f;
            color: #fff;
            border: 1px solid #8cc63f;
            &:focus{
                box-shadow:unset;
            }
    }
`;

export const ButtonsWrap = styled.div`
    display: flex;
    align-items: center;
     justify-content: flex-end;
    margin: 10px 0px;
    .submit-btn{
        background: transparent;
        border: 1px solid rgba(0,0,0,.1);
        padding: .7rem 1.5rem;
        -webkit-transition: all 400ms cubic-bezier(0.445,0.5,0.55,0.95);
        transition: all 400ms cubic-bezier(0.445,0.5,0.55,0.95);
        border-radius: 50rem;
        font-size: 1rem;
        color: #474f56;
        font-weight: 600;
        width: 40%;
        margin-right:10px;
        &:hover{
            background-color: #8cc63f;
            color: #fff;
            border: 1px solid #8cc63f;
        }
    }
    .cancel-btn{
        background: transparent;
        border: 1px solid rgba(0,0,0,.1);
        padding: .7rem 1.5rem;
        -webkit-transition: all 400ms cubic-bezier(0.445,0.5,0.55,0.95);
        transition: all 400ms cubic-bezier(0.445,0.5,0.55,0.95);
        border-radius: 50rem;
        font-size: 1rem;
        color: #474f56;
        font-weight: 600;
        width: 40%;
        margin-right:10px;
        background-color: #8cc63f;
        color: #fff;
        border: 1px solid #8cc63f;
    }
`;

export const FlexWrap = styled.div`
    display:flex;
    align-items:center;
    margin-right:10px;
    margin-bottom: 13px;
    p{
        font-size:16px;
        color:#333;
        margin:0px;
        margin-left:12px
    }
    input{
        width: 20px;
        height: 20px;
        margin: 0px;
    }
`
export const FlexContainer = styled.div`
    display:flex;
    align-items:center;
    margin-bottom:10px;
    flex-wrap:wrap;
`



// WEBPACK FOOTER //
// ./src/component/Modaldoctor/styles.js